import React from "react"

interface IProps {
  user: IUser
  x: number
  y: number
  width: number
  height: number
  clipPath?: string
}

const Avatar: React.FC<IProps> = ({ user, x, y, width, height, clipPath }) => {
  const [imgError, setImgError] = React.useState(false)
  const shouldShowInitials = imgError || !user.photo_url

  if (shouldShowInitials) {
    const name = user.name?.trim() || user.email?.split("@")[0] || ""
    let initials = name
      .split(" ")
      .map(word => word[0]?.toUpperCase())
      .slice(0, 2)
      .join("")

    if (initials.length === 1 && name.length > 1) {
      initials = name.substring(0, 2).toUpperCase()
    }

    return (
      <g>
        <circle
          cx={x + width / 2}
          cy={y + height / 2}
          r={width / 2}
          fill="#e0e0e0"
          stroke="#fff"
          strokeWidth="2"
        />
        <text
          x={x + width / 2}
          y={y + height / 2}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={width > 20 ? "14" : "8"}
          fontWeight="bold"
          fill="#555"
        >
          {initials}
        </text>
      </g>
    )
  }

  return (
    <image
      href={user.photo_url}
      x={x}
      y={y}
      width={width}
      height={height}
      clipPath={clipPath}
      onError={() => setImgError(true)}
    />
  )
}

export default Avatar
